<template>
  <application-layout>
    <v-main>
      <v-container v-if="aceConfigs">
        <h1 class="mb-4">Manage ACE Settings</h1>
        <v-tabs show-arrows>
          <v-tab
            data-testid="ace-setting-deals-tab"
            class="ace-settings-deals-tab"
          >
            Deals
          </v-tab>
          <v-tab
            data-testid="ace-new-customers-tab"
            class="ace-new-customers-tab"
          >
            New Customers
          </v-tab>
          <v-tab
            data-testid="ace-existing-customers-tab"
            class="ace-existing-customers-tab"
          >
            Existing Customers
          </v-tab>
          <v-tab
            data-testid="ace-past-customers-tab"
            class="ace-past-customers-tab"
          >
            Past Customers
          </v-tab>
          <v-tab-item :style="darkTheme ? darkThemeBgColor : ''">
            <h2 class="mt-4">Deals ACE Settings</h2>
            <settings-config
              class="mt-4"
              :config="aceConfigs.deals"
              @save-global-ace-configs="saveGlobalAceConfigs"
            />
          </v-tab-item>
          <v-tab-item :style="darkTheme ? darkThemeBgColor : ''">
            <h2 class="mt-4">New Customers ACE Settings</h2>
            <settings-config
              class="mt-4"
              :config="aceConfigs.new_customers"
              @save-global-ace-configs="saveGlobalAceConfigs"
            />
          </v-tab-item>
          <v-tab-item :style="darkTheme ? darkThemeBgColor : ''">
            <h2 class="mt-4">Existing Customers ACE Settings</h2>
            <settings-config
              class="mt-4"
              :config="aceConfigs.existing_customer"
              @save-global-ace-configs="saveGlobalAceConfigs"
            />
          </v-tab-item>
          <v-tab-item :style="darkTheme ? darkThemeBgColor : ''">
            <h2 class="mt-4">Past Customers ACE Settings</h2>
            <settings-config
              class="mt-4"
              :config="aceConfigs.past_customers"
              @save-global-ace-configs="saveGlobalAceConfigs"
            />
          </v-tab-item>
        </v-tabs>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import SettingsConfig from "@/views/ace/partials/SettingsConfig.vue";

export default {
  data() {
    return {
      loading: false,
      aceConfigs: null,
      modal: false,
      itemType: "settings config"
    };
  },

  methods: {
    getGlobalAceConfigs() {
      this.loading = true;

      this.$store.dispatch("getGlobalSetting", "global_ace_configs")
        .then(resp => {
          this.aceConfigs = JSON.parse(resp.data.setting.value);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    saveGlobalAceConfigs() {
      this.loading = true;

      const payload = {
        ident: "global_ace_configs",
        value: JSON.stringify(this.aceConfigs)
      };

      this.$store.dispatch("updateGlobalSetting", payload)
        .finally(() => {
          this.loading = false;
        });
    }
  },

  computed: {
    darkThemeBgColor() {
      return this.$store.state.app.darkThemeBgColor;
    },
    darkTheme() {
      return this.$vuetify.theme.dark;
    }
  },

  created() {
    this.getGlobalAceConfigs();
  },

  components: {
    ApplicationLayout,
    SettingsConfig
  }
};
</script>
